import { __assign } from "tslib";
import { createFakePostResponder, createFakePutResponder, createFakeDeleteResponder, isWildcard, createFakeGetResponder } from './../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createLabelsApi } from './';
export var createLabelsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createLabelsApi('', fakeHttp);
    var testKit = {
        whenGetLabels: function () { return createFakeGetResponder(fakeHttp, '/labels'); },
        whenAddLabel: createFakePostResponder(fakeHttp, '/labels'),
        whenRenameLabel: function (renameLabelDto) {
            var id = isWildcard(renameLabelDto) ? 'default-label-id' : renameLabelDto.id;
            return createFakePutResponder(fakeHttp, "/labels/" + id)(renameLabelDto);
        },
        whenDeleteLabel: function (deleteLabelDto) {
            var id = isWildcard(deleteLabelDto) ? 'default-label-id' : deleteLabelDto.id;
            return createFakeDeleteResponder(fakeHttp, "/labels/" + id + "?permanentDelete=true");
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map